import React from 'react'
import styled from 'styled-components'
import { colors, utils, flex, typography } from '../styles'

const EmbedWrapper = styled.figure`
  width: 37rem;
  max-width: 100vmin;
`
const Embed = styled.div`
  position: relative;
  padding-top: 56.25%;
  background: url(${props => props.bg}) 50% 50% no-repeat;
  background-size: cover;
  border: 3px solid ${colors.blueText};
`

const Lock = styled.a`
  ${utils.absFill(0)}
  ${flex.vertical.centerBoth}
  ${typography.noDecoration.white.uppercase.h2.bold}
  opacity: 0;
  background: rgba(0,0,0,0.8);
  transition: opacity 0.2s;
  &:hover {
    opacity: 1;
  }
`

const SVG = styled.svg`
  width: 8rem;
  stroke: ${colors.offWhite};
  stroke-width: 2;
  fill: none;
`

export default ({ ep }) => (
  <EmbedWrapper>
    <Embed bg={ep.banner}>
      <Lock onClick={() => window.ga && window.ga('send', 'event', 'lock', 'click', ep.number)}
            href="https://gum.co/frontendcenter" target="_blank">
        <SVG viewBox="0 0 100 100">
          <g transform="translate(4.000000, 4.000000)">
            <circle id="Oval-2" cx="46" cy="51" r="3"></circle>
            <path d="M30,55.9999993 L30,38.0665242 C30,29.1932279 37.163444,22 46,22 C54.3729839,22 62,27.3644497 62,38.0665242 L62,56" id="Oval-Copy" strokeLinecap="round"></path>
            <path d="M46,72 C54.836556,72 62,64.836556 62,56 C62,40 62,40 46,40 C30,40 30,40 30,56 C30,64.836556 37.163444,72 46,72 Z" id="Oval-Copy"></path>
            <path d="M46,55 L46,63" id="Line" strokeLinecap="round"></path>
          </g>
        </SVG>
        Subscribe to watch
      </Lock>
    </Embed>
  </EmbedWrapper>
)



/** WEBPACK FOOTER **
 ** ./src/components/EpisodePreview.js
 **/